/***
 * Created on 2023/10/26
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import PasswordInput from "../common/form/password_input";
import {useOnChange, useLanguage} from "common/Hook";
import {getErrorMessage} from 'common/ServiceCommon';
import {useMutation, useQuery} from "@tanstack/react-query";
import {apiGet, apiPost} from "../../service/api";
// import md5 from "blueimp-md5";
import ResetSuccess from "./reset_success";


function ResetPassword({params}) {
    const { t, i18n } = useTranslation();
    useLanguage(i18n);
    const [newPasswordStatus, setNewPasswordStatus] = useState(false);
    const [confirmPasswordStatus, setConfirmPasswordStatus] = useState(false);
    const [success, setSuccess] = useState(location.hash === '#success');
    const [errorMessage, setErrorMessage] = useState();
    const {values, onChange} = useOnChange({
        new_password: '',
        confirm_password: ''
    });

    const {isError} = useQuery({
        queryKey: ['check_forget_password_token'],
        queryFn: async () => await apiGet(`/ajax/check_reset_password_token?token=${params?.token}`),
        enabled: !!params?.token
    });

    const resetPasswordMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/resetPassword', data),
        onSuccess: data => {
            window.location.replace('/resetpassword#success');
            setSuccess(true);
        },
        onError: (error, variables, context) => {
            if (location.hash !== '#success') {
                setErrorMessage(getErrorMessage(t, error.cause?.code));
            }
        }
    });

    const onSubmit = async () => {
        setErrorMessage(null);
        const paths = window.location.pathname.split('/');
        const data = {
            password: values.new_password,
            token: paths?.[2]
        }
        await resetPasswordMutation.mutateAsync(data);
    }

    if (!params?.token && !success) {
        location.href = '/error?code=1050007';
    }

    useEffect(() => {
        if (isError) {
            if (location.hash !== '#success') {
                location.href = '/error?code=1050007';
            }
        }
    }, [isError]);

    return (
        <>
            {success && <ResetSuccess />}
            {!success &&
                <section className="common-page-wrapper">
                    <div className="common-page-header">{t('@Reset Password@')}</div>
                    <div className="common-page-body">
                        <p>{t('@Once you change your password, you will need to sign in you QNAP ID on all of you devices such as browsers, mobile devices and KoiBot, including when you sign in with Facebook or Google except QNAP devices that you have given account access.@')}</p>

                        <div className="common-form-group">
                            <PasswordInput
                                label={t('@New Password@')}
                                placeholder={t('@New Password@')}
                                name='new_password'
                                value={values.new_password}
                                onChange={onChange}
                                showStrength={true}
                                ignoreRules={false}
                                showTip={true}
                                status={setNewPasswordStatus}
                                required={true}/>

                            <PasswordInput
                                label={t('@Confirm New Password@')}
                                placeholder={t('@Confirm New Password@')}
                                name='confirm_password'
                                value={values.confirm_password}
                                matchInput={values.new_password}
                                onChange={onChange}
                                showStrength={false}
                                showTip={false}
                                status={setConfirmPasswordStatus}
                                required={true}/>

                            {errorMessage && <p className="text-error mt-10">{errorMessage}</p>}
                        </div>
                    </div>
                    <div className="common-page-footer">
                        <div className="q-btn-group btn-align-right">
                            <button className="q-btn q-btn--primary btn-medium btn-rounded-normal"
                                    disabled={!newPasswordStatus || !confirmPasswordStatus || (values.new_password.length <= 0 || values.confirm_password <= 0)}
                                    onClick={onSubmit}>{t('@Submit@')}</button>
                        </div>
                    </div>
                </section>
            }
        </>
    );
}

export default ResetPassword;